/**
 * Eight sparks off whatever was just pressed, fixed rather than random so a collection looks the same
 * every time and nothing has to be generated during a render.
 *
 * It fills its nearest positioned ancestor, so the caller decides what the burst comes out of — the
 * coin in the wallet, or the collect button on a row.
 */
const SPARKS = [
	{ x: "34px", y: "0px" },
	{ x: "24px", y: "-24px" },
	{ x: "0px", y: "-34px" },
	{ x: "-24px", y: "-24px" },
	{ x: "-34px", y: "0px" },
	{ x: "-24px", y: "24px" },
	{ x: "0px", y: "34px" },
	{ x: "24px", y: "24px" },
];

function Burst() {
	return (
		<span aria-hidden="true" className="pointer-events-none absolute inset-0">
			{SPARKS.map((spark, index) => (
				<span
					key={spark.x + spark.y}
					className="reward-spark absolute left-1/2 top-1/2 -ml-[3px] -mt-[3px] size-1.5 rounded-full bg-amber-400"
					style={
						{
							"--spark-x": spark.x,
							"--spark-y": spark.y,
							"--spark-delay": `${index * 22}ms`,
						} as React.CSSProperties
					}
				/>
			))}
		</span>
	);
}

export default Burst;
